import React, { useState } from 'react'
import { Button, DropdownProps, Icon, List, Popup, Table } from 'semantic-ui-react'
import DropdownComponent from '../../../../../components/Dropdown/DropdownComponent'
import ConfirmDeleteModal from '../../../../../components/Modal/ConfirmDeleteModal'
import DeleteNotAllowModal from '../../../../../components/Modal/DeleteNotAllowModal'
import ValidationInput from '../../../../../components/ValidationInput/ValidationInput'
import { _initialBudgetCosts } from '../../../../../fixtures/projectFixtures'
import { abbreviateString } from '../../../../../utils/abbreviateString'
import { currencyFormat } from '../../../../../utils/currencyFormat'
import { sortTasksByKey } from '../../../../../utils/sort'
import { IProjectBudgetCost } from '../../../types/costs'
import { IDirectCost } from '../../../types/directAndPassTroughCosts'
import { IProject } from '../../../types/project'
import '../BudgetTableComponent.css'
import { taskDisplayName } from '../../../../../utils/formatters'


interface Props {
  project: IProject
  costs: IProjectBudgetCost[]
  calcTotalCost: number
  name: string
  directCosts: IDirectCost[]
  createBudgetCost: (projId: string | number, cost: IProjectBudgetCost) => Promise<IProjectBudgetCost>
  updateBudgetCost: (projId: string | number, cost: IProjectBudgetCost) => Promise<IProjectBudgetCost>
  deleteBudgetCost: (projId: string | number, cost: IProjectBudgetCost) => Promise<string | number | void>
  getDirectCosts: () => void
}

interface IInputValueHelper {
  unit_price: string
  quantity: string
}

const ServiceProviderExternalBudgetTable = (props: Props): JSX.Element => {
  const { project, costs, calcTotalCost, name, directCosts, createBudgetCost, updateBudgetCost, deleteBudgetCost, getDirectCosts } = props
  const [selectedCost, setSelectedCost] = useState<IProjectBudgetCost>(_initialBudgetCosts[0])
  const [renderNotAllowToDelete, setNotAllowDel] = useState<boolean>(false)
  const [renderDeleteModal, setRenderDeleteModal] = useState(false)
  const [deleteCost, setDeleteCost] = useState<IProjectBudgetCost>()
  const [inputValues, setInputValues] = useState<IInputValueHelper>({ unit_price: '', quantity: '' })

  console.log('[ServiceProvider] Component received costs:', costs)
  console.log('[ServiceProvider] Component received directCosts:', directCosts)

  const maxLength15ValidationRule = new RegExp("^.{0,25}$")
  const invalidMaxLength25ValidationRuleMsg = 'Max number of characters exceeded. There are only 25 chars allowed.'
  const maxLength26 = 26

  const confirmDeleteModal = (action: 'cancel' | 'delete') => {
    if (action === 'delete' && deleteCost) {
      deleteBudgetCost(project.id, deleteCost).then(() => {
        getDirectCosts()
      })
    }
    setDeleteCost(undefined)
    setRenderDeleteModal(false)
  }

  const renderCollapseRows = () => {
    return (
      <Table.Row style={{ boxShadow: 'inset 0rem 0rem 10rem #F4F7F9', borderRadius: 0, height: '50px' }}>
        <Table.Cell colSpan={5} style={{ borderTop: 'none' }}>
          <div style={{ paddingLeft: '40px', fontSize: '1.28rem', color: '#172533', letterSpacing: '.02rem', fontWeight: 'bold' }}>{name}</div>
        </Table.Cell>
        <Table.Cell style={{ borderTop: 'none', fontWeight: 500 }}>
          {calcTotalCost !== 0 ?
            <div style={{ display: 'flex', float: 'right', color: '#232C58' }}>
              <p style={{ margin: 0 }}>{currencyFormat(calcTotalCost)[0]} {currencyFormat(calcTotalCost).split(',')[0].replace(currencyFormat(calcTotalCost)[0], '')}</p>
              <p style={{ color: '#BEC8C3' }}>,{currencyFormat(calcTotalCost).split(',')[1]}</p>
            </div>
            : <p style={{ color: '#232C58', textAlign: 'right' }}>€ 0,00</p>}</Table.Cell>
        <Table.Cell style={{ borderTop: 'none' }} />
      </Table.Row>
    )
  }

  const renderRows = () => {
    return costs.map((a, idx) => {
      const total = +a.unit_price * +a.quantity
      console.log(`[ServiceProvider] Row ${idx}:`, {
        id: a.id,
        position: a.position,
        linked_position_id: a.linked_position_id,
        linked_position_name: a.linked_position_name,
        linked_position_title: (a as any).linked_position_title,
        fullObject: a
      })
      if (+a.id !== selectedCost.id) {
        return (
          <Table.Row key={idx}>
            <Table.Cell className={idx % 2 ? 'custom-left-border-cell' : ''} style={{ border: 'none', minWidth: '260px' }}>
              <strong style={{ color: '#232C58', textAlign: 'left', paddingLeft: '40px' }}>{a.position}</strong>
            </Table.Cell>

            <Table.Cell style={{ borderTop: 'none', minWidth: '250px' }} textAlign='left'>
              <div style={{ display: 'flex', alignItems: 'baseline', width: '180px' }}>
                <Icon name='linkify' style={{ position: 'relative', zIndex: 1, color: '#08D6A1', cursor: 'default' }} />
                <strong style={{ color: '#232C58', textAlign: 'left' }}>{a.linked_position_name}</strong>
              </div>
            </Table.Cell>

            <Table.Cell style={{ borderTop: 'none', minWidth: '230px' }}>
              <p style={{ color: '#232C58', textAlign: 'left', width: '138px' }}>{a.supplier}</p>
            </Table.Cell>

            <Table.Cell style={{ borderTop: 'none' }}>
              <p style={{ color: '#232C58', textAlign: 'center', fontWeight: 'bold' }}>{a.quantity}</p>
            </Table.Cell>

            <Table.Cell style={{ borderTop: 'none', fontWeight: 500 }}>
              {a.unit_price !== 0 ?
                <div style={{ display: 'flex', float: 'right', color: '#232C58', minWidth: '100px', justifyContent: 'flex-end' }}>
                  <p style={{ margin: 0 }}>{currencyFormat(+a.unit_price)[0]} {currencyFormat(+a.unit_price).split(',')[0].replace(currencyFormat(+a.unit_price)[0], '')}</p>
                  <p style={{ color: '#BEC8C3' }}>,{currencyFormat(+a.unit_price).split(',')[1]}</p>
                </div>
                : <p style={{ color: '#232C58', textAlign: 'right' }}>- €</p>}
            </Table.Cell>

            <Table.Cell style={{ borderTop: 'none', minWidth: '110px', fontWeight: 500 }} textAlign='right'>
              {total !== 0 ?
                <div style={{ display: 'flex', float: 'right', color: '#232C58' }}>
                  <p style={{ margin: 0 }}>{currencyFormat(total)[0]} {currencyFormat(total).split(',')[0].replace(currencyFormat(total)[0], '')}</p>
                  <p style={{ color: '#BEC8C3' }}>,{currencyFormat(total).split(',')[1]}</p>
                </div>
                : <p style={{ color: '#232C58', textAlign: 'right' }}>- €</p>}
            </Table.Cell>

            <Table.Cell className={idx % 2 ? 'custom-right-border-cell' : ''} style={{ borderTop: 'none', minWidth: '110px', maxWidth: '110px' }} textAlign='center'>
              {renderAdditionalButtons(a)}
            </Table.Cell>

          </Table.Row>
        )
      }
      return renderEditableRow(idx)
    })
  }

  const renderEditableRow = (idx: number) => {
    return (
      <Table.Row key={idx}>
        <Table.Cell className={idx % 2 ? 'custom-left-border-cell cell-no-padding' : 'cell-no-padding'} style={{ borderTop: 'none', minWidth: '260px' }}>
          <ValidationInput
            value={selectedCost.position}
            onChange={e => inputChange(e, 'position')}
            placeholder='Enter Position'
            paddingLeft='40px'
            width='184px'
            maxLength={maxLength26}
            validatePattern={maxLength15ValidationRule}
            invalidMessage={invalidMaxLength25ValidationRuleMsg}
          />
        </Table.Cell>

        <Table.Cell className='cell-no-padding' style={{ borderTop: 'none' }} textAlign='left'>
          {renderLinkedPositionDropdown()}
        </Table.Cell>

        <Table.Cell className='cell-no-padding' style={{ borderTop: 'none' }} textAlign='left'>
          <ValidationInput
            value={selectedCost.supplier}
            onChange={e => inputChange(e, 'supplier')}
            placeholder='Enter Supplier'
            width='138px'
            maxLength={maxLength26}
            validatePattern={maxLength15ValidationRule}
            invalidMessage={invalidMaxLength25ValidationRuleMsg}
          />
        </Table.Cell>

        <Table.Cell className='cell-no-padding' style={{ borderTop: 'none' }} textAlign='center'>
          <ValidationInput
            type='number'
            wholeNumber={true}
            value={inputValues?.quantity}
            onChange={(e, v, c) => inputChange(e, 'quantity', c)}
            placeholder='Enter #'
            width='66px'
          />
        </Table.Cell>

        <Table.Cell className='cell-no-padding' style={{ borderTop: 'none' }} textAlign='right'>
          <ValidationInput
            type='number'
            value={inputValues?.unit_price}
            onChange={(e, v, c) => inputChange(e, 'unit_price', c)}
            width='100px'
            placeholder='€ 0,00'
            zIndex={1}
            symbol='€'
            boldSymbol={true}
            className='right-aligned'
            symbolLeft={true}
          />
        </Table.Cell>

        <Table.Cell className='cell-no-padding' style={{ borderTop: 'none', minWidth: '110px' }} textAlign='right'>
          {+selectedCost.quantity !== 0 && +selectedCost.unit_price !== 0 ?
            <div style={{ display: 'flex', float: 'right', color: '#232C58' }}>
              <p style={{ margin: 0 }}>{currencyFormat(+selectedCost.unit_price * +selectedCost.quantity)[0]} {currencyFormat(+selectedCost.unit_price * +selectedCost.quantity).split(',')[0].replace(currencyFormat(+selectedCost.unit_price * +selectedCost.quantity)[0], '')}</p>
              <p style={{ color: '#BEC8C3' }}>,{currencyFormat(+selectedCost.unit_price * +selectedCost.quantity).split(',')[1]}</p>
            </div>
            : <p style={{ color: '#747678', textAlign: 'right', marginRight: '.2rem' }}>€ 0,00</p>}
        </Table.Cell>

        <Table.Cell className={idx % 2 ? 'custom-right-border-cell cell-no-padding' : 'cell-no-padding'} style={{ borderTop: 'none', width: '110px', maxWidth: '110px' }} textAlign='center'>
          <Button disabled={disableSaveButton()} onClick={() => createCost()} circular size='tiny' style={{ cursor: disableSaveButton() ? 'no-drop' : 'pointer', backgroundColor: '#00D85A', height: '1rem', width: '1rem', marginTop: '1rem' }} icon={<Icon name='check' size='small' style={{ color: 'white', position: 'relative', left: '-.3rem', top: '-.5rem' }} />} />
          <Button onClick={() => setSelectedCost(_initialBudgetCosts[0])} circular size='tiny' style={{ marginLeft: '1rem', backgroundColor: '#FA5953', height: '1rem', width: '1rem', marginTop: '1rem', cursor: 'pointer' }} icon={<Icon name='close' size='small' style={{ color: 'white', position: 'relative', left: '-.3rem', top: '-.5rem' }} />} />
        </Table.Cell>
      </Table.Row>
    )
  }

  const dropdownChange = (data: DropdownProps) => {
    if (data && data.value) {
      const selectedDirectCost = directCosts.find(dc => dc.id.toString() === data.value!.toString())!
      console.log('[ServiceProvider] Dropdown change:', {
        selectedValue: data.value,
        selectedDirectCost: selectedDirectCost,
        offer_position: selectedDirectCost.offer_position
      })
      setSelectedCost({
        ...selectedCost,
        linked_position_id: data.value!.toString(),
        linked_position_name: selectedDirectCost.offer_position
      })
    }
  }

  const renderLinkedPositionDropdown = () => {
    const sortedDirectCosts = sortTasksByKey(directCosts, 'key', 'offer_position')
    const options = sortedDirectCosts.map(dc => {
      return {
        key: dc.id.toString(),
        value: dc.id.toString(),
        text: abbreviateString(taskDisplayName(dc.key, dc.offer_position), 16, true, 18)
      }
    })
    return (
      <div style={{ display: 'flex', alignItems: 'baseline', width: '100%' }}>
        <Icon name='linkify' style={{ position: 'absolute', zIndex: 1, color: '#9C9D9F', padding: '8px' }} />
        <DropdownComponent
          className='caret-icon-dropdown dropdown-with-icon no-padding-dropdown-with-icon'
          options={options}
          width='180px'
          changeOption={(e, data) => dropdownChange(data)}
          value={selectedCost.linked_position_id}
          placeholder={'Link position'}
          closeOnChange={true}
        />
      </div>
    )
  }

  const disableSaveButton = () => {
    return !(
      selectedCost.position !== ''
      && selectedCost.quantity !== 0
      && selectedCost.unit_price !== 0
      && selectedCost.linked_position_id
      && selectedCost.position.length < maxLength26
      && selectedCost.supplier.length < maxLength26
    )

  }

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>, key: 'supplier' | 'position' | 'quantity' | 'unit_price', converted?: number) => {
    const value = key === 'position' || key === 'supplier' ? event.target.value : (converted ?? 0)
    setSelectedCost({ ...selectedCost, [key]: value })
    if (key === 'quantity' || key === 'unit_price') {
      setInputValues(prev => { return { ...prev, [key]: event.target.value } })
    }
  }

  const createCost = () => {
    const costPayload = {
      ...selectedCost,
      total_cost: +selectedCost.quantity * +selectedCost.unit_price
    }
    console.log('[ServiceProvider] createCost payload:', costPayload)
    if (selectedCost.id === -1) {
      createBudgetCost(project.id, costPayload).then(() => { setSelectedCost(_initialBudgetCosts[0]), getDirectCosts() })
    } else {
      updateBudgetCost(project.id, costPayload).then(() => { setSelectedCost(_initialBudgetCosts[0]), getDirectCosts() })
    }
  }

  const handleOptionSelect = (option: 'edit' | 'delete', cost: IProjectBudgetCost) => {
    if (option === 'edit') {
      setSelectedCost(cost)
      setInputValues({
        unit_price: +cost.unit_price !== 0 ? cost.unit_price.toString().replace('.', ',') : '',
        quantity: +cost.quantity !== 0 ? cost.quantity.toString().replace('.', ',') : ''
      })
    } else {
      setDeleteCost(cost)
      if (cost.payments.length > 0) {
        setNotAllowDel(true)
      } else {
        setRenderDeleteModal(true)
      }
    }
  }

  const renderAdditionalDropdown = (cost: IProjectBudgetCost) => {
    return (
      <List style={{ width: '7rem' }}>
        {<List.Item content={'Edit'} onClick={() => handleOptionSelect('edit', cost)} style={{ cursor: 'pointer' }} />}
        <List.Item content={'Delete'} onClick={() => handleOptionSelect('delete', cost)} style={{ cursor: 'pointer' }} />
      </List>
    )
  }

  const renderAdditionalButtons = (cost: IProjectBudgetCost) => {
    return (
      <Popup
        basic
        trigger={<Button size='small' secondary={true} icon={<Icon name='ellipsis horizontal' />} style={{ height: '1.8rem', padding: '0', borderRadius: '.57rem', width: '1.8rem' }} />}
        content={renderAdditionalDropdown(cost)}
        on='click'
        position='bottom left'
      />
    )
  }

  const confirmCloseNotAllow = () => {
    setNotAllowDel(false)
  }

  const addPosition = () => {
    console.log('[ServiceProvider] addPosition called, project:', project)
    console.log('[ServiceProvider] cost_rate_billing:', project.cost_rate_billing)
    const _id = project.cost_rate_billing.length !== 0 ? project.cost_rate_billing[0].id : (null as any)
    const _name = project.cost_rate_billing.length !== 0 ? project.cost_rate_billing[0].name : ''
    const new_cost: IProjectBudgetCost = {
      id: -1,
      position: '',
      supplier: '',
      quantity: 0,
      unit_price: 0,
      total_cost: 0,
      phases: [],
      labels: [],
      project_cost_category_id: _id,
      project_cost_category_name: _name,
      thereof_paid: 0,
      position_status: 'open',
      payments: [],
      linked_position_id: undefined,
      linked_position_name: ''
    }
    setSelectedCost(new_cost)
    setInputValues({
      unit_price: '',
      quantity: ''
    })
  }

  const addPositionButton = () => {
    return (
      <Table.Row>
        <Table.Cell style={{ borderTop: 'none', background: 'white' }}>
          <Button
            className='button-add-item'
            inverted
            size='small'
            color='teal'
            onClick={() => addPosition()}
            content='Add Position'
            icon={<Icon name='plus' />}
            disabled={selectedCost.id !== ''}
            style={{
              float: 'left',
              width: '8.57rem',
              height: '2.14rem',
              borderRadius: '.34rem',
              padding: '0rem',
              color: '#08D6A1',
              backgroundColor: '#CDF7EC',
              marginLeft: '40px'
            }}
          />
        </Table.Cell>
      </Table.Row>
    )
  }

  return (
    <React.Fragment>
      {renderCollapseRows()}
      {renderRows()}
      {selectedCost.id === -1 ? renderEditableRow(costs.length) : null}
      {addPositionButton()}
      <DeleteNotAllowModal
        open={renderNotAllowToDelete}
        deleteDisabled={true}
        title={'Delete Confirmation'}
        message={`Only positions without existing invoices can be deleted. To delete this position, please delete any invoice entry related to it first.`}
        userInput={confirmCloseNotAllow} />
      <ConfirmDeleteModal open={renderDeleteModal} userInput={confirmDeleteModal} />
    </React.Fragment>
  )
}

export default ServiceProviderExternalBudgetTable
